export default function Microwave() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <g clipPath="url(#clip0_3838_13587)">
                <path
                    d="M31.125 7.875H4.875C4.04657 7.875 3.375 8.54657 3.375 9.375V26.625C3.375 27.4534 4.04657 28.125 4.875 28.125H31.125C31.9534 28.125 32.625 27.4534 32.625 26.625V9.375C32.625 8.54657 31.9534 7.875 31.125 7.875Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M24.75 20.25H29.25" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M24.75 23.625H29.25" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M20.375 11.25H7.75C7.19772 11.25 6.75 11.6977 6.75 12.25V23.75C6.75 24.3023 7.19772 24.75 7.75 24.75H20.375C20.9273 24.75 21.375 24.3023 21.375 23.75V12.25C21.375 11.6977 20.9273 11.25 20.375 11.25Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="27" cy="14.625" r="2.25" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_3838_13587">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
